/**
 * Date-extensions locale Vietnamese [vi]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('vi', {
    monthNames: ['Tháng 1','Tháng 2','Tháng 3','Tháng 4','Tháng 5','Tháng 6','Tháng 7','Tháng 8','Tháng 9','Tháng 10','Tháng 11','Tháng 12'],
    monthShortNames: ['Th01','Th02','Th03','Th04','Th05','Th06','Th07','Th08','Th09','Th10','Th11','Th12'],
    dayNames: ['Chủ nhật','Thứ hai','Thứ ba','Thứ tư','Thứ năm','Thứ sáu','Thứ bảy'],
    dayShortNames: ['CN','T2','T3','T4','T5','T6','T7']
});
